import { type LeaveAbsenceMode } from "./leaveRequestTimes";
import { isSingleDayLeaveRequestType, type LeaveRequestType } from "./types";

export type ResolveLeaveRequestDateToResult =
    | { ok: true; dateTo: string | null }
    | { ok: false; error: "endDateRequired" };

/**
 * Maps form date fields to the create payload `date_to`.
 * Illness may omit the end date (ongoing). A weekly extracurricular may omit it too.
 * Other reasons require an end date.
 */
export function resolveLeaveRequestDateTo(
    reason: LeaveRequestType,
    absenceMode: LeaveAbsenceMode,
    dateFrom: string,
    dateTo: string,
    options?: { recurring?: boolean },
): ResolveLeaveRequestDateToResult {
    const trimmedDateFrom = dateFrom.trim();
    const trimmedDateTo = dateTo.trim();

    if (
        isSingleDayLeaveRequestType(reason) ||
        absenceMode === "arrives" ||
        absenceMode === "leaves"
    ) {
        return { ok: true, dateTo: trimmedDateFrom };
    }

    if (
        reason === "illness" ||
        (reason === "extracurricular" && options?.recurring)
    ) {
        return { ok: true, dateTo: trimmedDateTo || null };
    }

    if (!trimmedDateTo) {
        return { ok: false, error: "endDateRequired" };
    }

    return { ok: true, dateTo: trimmedDateTo };
}
